import React from 'react'
import { css } from '@emotion/core'
import { colors } from '@fs/zion-ui'

const StreakNotificationsCss = css`
  flex: 1;
  padding: 15px;
  border-radius: 8px;
  background-color: ${colors.yellow03};
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size: 16px;
  gap: 12px;
  font-weight: 600;
  line-height: 22px;
  max-width: 90vw;
`
const StreakNotification = ({ icon, message }) => {
  return (
    <div css={StreakNotificationsCss}>
      <img src={icon} alt="" />
      <div>{message}</div>
    </div>
  )
}
export default StreakNotification
